import React from 'react';
import DTOGoalsRatio from './DTOGoalsRatio';
import GoalsRatioPresenter from './GoalsRatioPresenter';

import { useTranslation } from 'react-i18next';
function GoalsRatioController() {
  const { t } = useTranslation();

  return (
    <div>
      <DTOGoalsRatio />
      <GoalsRatioPresenter trans={t} />
    </div>
  );
}

export default GoalsRatioController;
